import Skeleton from "react-loading-skeleton";
import { homeBannerDesktop } from "../../../assets";
import { useState } from "react";
import { Breakpoint } from "react-socks";

const MainBanner = ({ homeData }) => {
  console.log("homedata", homeData?.mainBanners);
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <div className="w-full h-dvh object-cover">
      {!isImageLoaded && (
        <Skeleton className="h-full w-full aspect-auto" baseColor="#EDE5DE" />
      )}
      <Breakpoint large up style={{ objectFit: "cover", height: "100dvh" }}>
        <img
          src={homeData?.mainBanners?.desktop}
          alt="Bridal Jewelry"
          className={`h-full w-full object-cover ${
            isImageLoaded ? "block" : "hidden"
          }`}
          onLoad={() => setIsImageLoaded(true)}
        />
      </Breakpoint>
      <Breakpoint medium down style={{ objectFit: "cover", height: "100dvh" }}>
        <img
          src={homeData?.mainBanners?.mobile}
          alt="Bridal Jewelry"
          className={`h-full w-full object-cover ${
            isImageLoaded ? "block" : "hidden"
          }`}
          onLoad={() => setIsImageLoaded(true)}
        />
      </Breakpoint>
    </div>
  );
};
export default MainBanner;
